<template>
  <div class="navbar">
    <nav class="nav has-shadow">
      <div class="container">
        <div class="nav-left">
          <router-link class="nav-item is-tab" to="/" exact>Sätt betyg</router-link>
          <router-link class="nav-item is-tab" to="/list-beers">Provade öl</router-link>
          <router-link class="nav-item is-tab" to="/add-new">Ny provning</router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'navbar'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Navbar.vue?5cabc280